import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Switch from 'react-switch'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const WWPitaBreadPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Size: item.Size,
    WholeWheatCert: item.WholeWheatCert,
  })
  const methods = useFormContext()
  const { onChangeReviewer, setSwitchReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { category, subCategory, Size, WholeWheatCert } = item
      setPackaging({
        category,
        subCategory,
        Size,
        WholeWheatCert,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <h6>Size {asterisk}</h6>
          <Controller
            as={Input}
            name="Size"
            placeholder={'12 - 48 ounces'}
            defaultValue={packaging.Size}
            control={methods.control}
            rules={{
              validate: Size => Size >= 12 && Size <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              message={'⚠ Size must be between 12 - 48 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>
              I certify that this product has “100% Whole Wheat” printed on the
              front label. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="WholeWheatCert"
            id="WholeWheatCert"
            control={methods.control}
            defaultValue={item.WholeWheatCert}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            rules={{
              validate: WholeWheatCert => WholeWheatCert === true,
            }}
            disabled={isDisabled}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="WholeWheatCert"
              message={
                '⚠ You must certify that this product has “100% Whole Wheat” printed on the front label.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

WWPitaBreadPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default WWPitaBreadPackageReview
